module.exports = __webpack_public_path__ + "4de1c87e28b25fd88066aac31eac56c1.MP3";